(function () {
  'use strict';

  var modals = document.querySelectorAll('[data-ae-fsg]');
  if (!modals.length) return;

  modals.forEach(function (modal) {
    var slides = Array.prototype.slice.call(modal.querySelectorAll('[data-ae-fsg-slide]'));
    var counter = modal.querySelector('[data-ae-fsg-counter]');
    var prevBtn = modal.querySelector('[data-ae-fsg-prev]');
    var nextBtn = modal.querySelector('[data-ae-fsg-next]');
    var closeBtn = modal.querySelector('[data-ae-fsg-close]');
    var backdrop = modal.querySelector('[data-ae-fsg-backdrop]');

    var currentIndex = 0;
    var lastFocused = null;

    function showSlide(index) {
      if (slides.length === 0) return;
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + slides.length;
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
    }

    function openModal(index) {
      lastFocused = document.activeElement;
      showSlide(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ae-fsg-open');
      if (closeBtn) requestAnimationFrame(function () { closeBtn.focus({ preventScroll: true }); });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ae-fsg-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    function next() { showSlide(currentIndex + 1); }
    function prev() { showSlide(currentIndex - 1); }

    var scope = modal.closest('section') || document;
    var triggers = scope.querySelectorAll('[data-ae-fsg-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var idx = parseInt(trigger.getAttribute('data-ae-fsg-trigger') || '0', 10);
        openModal(idx);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        next();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prev();
      }
    });
  });
})();
